import { faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function updateConfig() {
    return (
        <div data-cy="historic-icon-updateConfig">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.updateConfig" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faWrench} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
